import { ThermostatAdjustment } from '../../../types/thermostatAdjustment'
import { match } from 'ts-pattern'

export type AdjustmentType =
  | 'save_money'
  | 'pre-cooling'
  | 'demand_response'
  | 'other'

export function getAdjustmentType(
  adjustment: ThermostatAdjustment | undefined | null,
): AdjustmentType {
  return match(adjustment)
    .with({ source: 'COST_CATEGORY' }, () => 'save_money')
    .with({ source: 'PRE_CONDITIONING' }, () => 'pre-cooling')
    .with({ source: 'DEMAND_RESPONSE' }, () => 'demand_response')
    .otherwise(() => 'other') as AdjustmentType
}
